<template>
  <div>
    <el-dialog title="我要购买账号" :visible.sync="gmFormVisible" custom-class="dialog-t" width="890px" v-if="info" :before-close="clearDl">
      <div class="form">
        <div class="input_text lef" v-if="configQW&&configQW.display_weixin_buy==1">
          <span class="label lar">请添加购买专员</span>
          <span class="static">{{configQW.service_buy}}</span>
        </div>
         <div class="input_text lef" v-if="configQW&&configQW.display_qq_buy==1">
          <span class="label lar">请添加购买专员</span>
          <span class="static">{{configQW.qq_buy}}</span>
        </div>
        <div class="input_text lef">
          <span class="label lar">账号ID</span>
          <span class="static">{{userInfo.username}}</span>
        </div>
        <div class="input_text lef">
          <span class="label lar">您想购买的账号</span>
          <input type="text" class="text" v-model="info.account" readonly>
        </div>
        <div class="input_text lef">
          <span class="label lar">卖方一口价</span>
          <input type="text" class="text" v-model="sale_price" readonly>
        </div>
        <div class="input_text lef">
          <span class="label lar">您的最高报价</span>
          <input type="number" class="text" v-model="form.buy_price">
        </div>
        <div class="input_text lef">
          <span class="label lar">其他</span>
          <textarea class="textarea" v-model="form.others"></textarea>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBuy">确认提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { configResource } from '@/resource/resource'
const ERR_OK = 0
export default {
  name: 'bugDialog',
  props: {
      info: {
        type: Object
      },
      tel: {
        type: String
      }
  },
  data () {
    return {
      gmFormVisible: false,
      form: {
        buy_price: null, // *
        others: ''
      },
      configQW: ''
    }
  },
  created () {
    if (!this.config_info.bInfo) {
        this.getConfig()
      } else {
        this.configQW = this.config_info.bInfo
      }
    },
  computed: {
    sale_price() {
      if (this.info.sale_price) {
        return '￥' + this.info.sale_price
      }
    },
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  methods: {
    showDialog(state) {
      this.gmFormVisible = state
    },
    submitBuy() {
      if (!this.form.buy_price) {
        this.$alert('您的最高报价不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (Number(this.form.buy_price) < 0) {
        this.$alert('您的最高报价不能小于0', '温馨提示', {
          confirmButtonText: '确定'
        })
        this.form.buy_price = null
        return
      }
      let ret = {
        sale_id: this.info.id,
        buy_price: this.form.buy_price,
        others: this.form.others
      }
      this.$emit('submitbuy', ret)
      // this.gmFormVisible = false
    },
    clearDl(done) {
      done()
      this.clearForm()
    },
    clearForm() {
      this.form = {
        buy_price: null,
        others: ''
      }
    },
    getConfig () {
      configResource.config({ config: 'service_buy,qq_buy,display_qq_buy,display_weixin_buy' }).then(response => {
        response = response.body
          if (response.errcode === ERR_OK) {
            this.config_info.bInfo = response.data
            this.configQW = response.data
          }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// buyDialog.vue?4d144f34